"use client";

import { AlertBanner } from "@pamperedchef/design-system";
import { useEffect } from "react";

import { useAddToCartErrorStore } from "@/app/store";
import * as styles from "./AddToCartErrorBanner.module.scss";

/**
 * Shows the last add-to-cart failure from any card or bridge on the page, and
 * scrolls up to it because the add was usually triggered further down.
 */
export function AddToCartErrorBanner(): JSX.Element | null {
	const status = useAddToCartErrorStore((state) => state.status);
	const message = useAddToCartErrorStore((state) => state.message);
	const seq = useAddToCartErrorStore((state) => state.seq);
	const clear = useAddToCartErrorStore((state) => state.clear);

	useEffect(() => {
		clear();
	}, [clear]);

	useEffect(() => {
		if (status) {
			window.scrollTo({ top: 0, behavior: "smooth" });
		}
	}, [status, seq]);

	if (!status || !message) return null;

	return (
		<AlertBanner
			kind="error"
			content={message}
			cta={{ link: "", title: "" }}
			className={styles.banner}
		/>
	);
}
